import { TrackingEventAction } from '@izimi/modules';

export type AuthenticationMethodType =
  | 'personal'
  | 'company'
  | 'companyAndSisterCompanies'
  | 'heir';

export const mapAuthenticationMethodToTrackingAction = ({
  type,
}: {
  type: AuthenticationMethodType;
}) => {
  switch (type) {
    case 'company':
      return TrackingEventAction.CompanyActsAuthenticationMethodSelected;
    case 'personal':
      return TrackingEventAction.PersonalActsAuthenticationMethodSelected;
    case 'companyAndSisterCompanies':
      return TrackingEventAction.SisterCompanyActsAuthenticationMethodSelected;
    default:
      return TrackingEventAction.HeirAuthenticationMethodSelected;
  }
};
